import { actions, constants, helpers, selectors } from 'app-webtech-core';
import { showInfoBanner, enterFullscreen, ccIncreaseMenuIndex } from 'app-modules/player/actions';
import { changeChannelDirection } from 'app-modules/guide/actions';
import { DIRECTION } from 'app-modules/guide/constants/actions';
import { DPAD_DOWN } from './types';
import { remoteControllerChannelUpButtonThunkAction as channelUp } from './channelUp';

const { GUIDE_LIST_ITEM_KIND } = constants.guide;

const isCategory = (kind) => kind === GUIDE_LIST_ITEM_KIND.CATEGORY;

const remoteControllerDPadDownButtonAction = helpers.actions.actionCreator(DPAD_DOWN);

export const remoteControllerDPadDownButtonThunkAction = () => async (dispatch, getState) => {
  await dispatch(remoteControllerDPadDownButtonAction());

  const state = getState();
  const { isFullscreen, isCCMenuOpen } = selectors.player.properties(state);
  const { isMenuOpen } = selectors.layout.properties(state);
  const location = selectors.location.page(state);
  const { list, selectedCategory } = selectors.guide.properties(state);
  const { selectedGenre } = selectors.vodGuide.properties(state);
  const categoriesList = list.filter((item) => isCategory(item.kind));
  let currentCategoryIndex = categoriesList.findIndex((i) => i.index === selectedCategory);
  currentCategoryIndex = currentCategoryIndex < 0 ? 0 : currentCategoryIndex;
  const nextCategory =
    currentCategoryIndex >= categoriesList.length - 1
      ? categoriesList[0]
      : categoriesList[currentCategoryIndex + 1];

  const genreList = selectors.vodContent.items(state);
  const currentGenreIndex = selectedGenre < 0 ? 0 : selectedGenre;
  const nextGenre = currentGenreIndex >= genreList.length - 1 ? 0 : currentGenreIndex + 1;
  const focusedArea = selectors.application.focusedArea(state);

  // checks to see if the cc settings menu is open
  if (!isCCMenuOpen && !isMenuOpen) {
    switch (location) {
      case 'Vod':
        await dispatch(
          actions.vodGuide.changeSelectedGenre({
            newGenre: nextGenre,
          }),
        );
        break;
      case 'Watch':
        if (focusedArea === 'SCHEDULE_LINES') {
          await dispatch(channelUp());
        } else {
          await dispatch(
            actions.guide.changeSelectedCategory({
              newCategory: nextCategory.index,
            }),
          );
          await dispatch(
            actions.guide.changeSelectedIndex({
              newIndex: nextCategory.index,
            }),
          );
        }
        break;
      default:
        await dispatch(changeChannelDirection(DIRECTION.DOWN));
        await dispatch(actions.guide.selectDown({ updateInfo: true, autoPlay: false }));
        await dispatch(showInfoBanner());
    }
  } else {
    // Goes to the next menu item
    await dispatch(ccIncreaseMenuIndex());
  }
};
